import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"

export type ComponentTableCsvFilterDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  fieldName: string | null
  inputValue: string
  onInputChange: (value: string) => void
  onClearField: () => void
  onApply: () => void
}

export function ComponentTableCsvFilterDialog({
  open,
  onOpenChange,
  fieldName,
  inputValue,
  onInputChange,
  onClearField,
  onApply,
}: ComponentTableCsvFilterDialogProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        onOpenChange(next)
      }}
    >
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>CSV filter</DialogTitle>
          <DialogDescription>
            Paste comma-separated values. Only rows matching one of these values will be fetched from
            the backend.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <div className="text-xs text-gray-500 dark:text-gray-400">
            Field:{" "}
            <span className="font-medium text-gray-700 dark:text-gray-200">
              {fieldName || "unknown"}
            </span>
          </div>
          <textarea
            value={inputValue}
            onChange={(event) => onInputChange(event.target.value)}
            placeholder="value1, value2, value3"
            className="w-full min-h-[120px] rounded-md border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 px-3 py-2 text-sm"
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClearField}>
            Clear field CSV
          </Button>
          <Button onClick={onApply}>Apply</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
